import Dialog from "../../base/dialog";
import {DialogActions, DialogContent, DialogTitle, Divider} from "@mui/material";
import React, {useCallback} from "react";
import {Row} from "reactstrap";
import Button from "../../base/button/button";
import ImportCsvFileDropzone from "../../app-specific/dropzone/import-csv-file";
import {exportCSVFile} from "../../../../core/services/utils/utils";


/**
 *
 * @param open
 * @param close
 * @param onParse
 * @param {Array<{
 *     name: string,
 *     title: string,
 *     generator: function(number): any,
 * }>} requiredFields
 * @param title
 * @param sampleFileTitle
 */
const UploadCsvFileDialog = ({
                                 open,
                                 close,
                                 onParse,
                                 requiredFields,
                                 title,
                                 sampleFileTitle,
                             }) => {


    /**
     * Creates and exports a sample csv formatted file that has the correct format for this dropzone.
     */
    const downloadSampleFile = () => {
        const entries = Array(10)
            .fill(null)
            .map((_, e) => Object.fromEntries(
                requiredFields.map(({title, generator}) => [title, generator(e + 1)])
            ))
        exportCSVFile(entries, sampleFileTitle);
    }

    /**
     * Closes the dialog and calls the onParse callback with the parsed file as its arg.
     * @type {(function(*): void)|*}
     */
    const onFileParsed = useCallback((parsedFile) => {
        onParse(parsedFile);
        close();
    }, [close, onParse])

    return (
        <>
            <Dialog
                open={open ?? false}
                setOpen={close}
                maxWidth={'sm'}
                className={'bound-dialog'}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id={'scroll-dialog-title'}>
                    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                        {title}
                    </p>
                    <Divider className='divider'/>
                </DialogTitle>
                <DialogContent>
                    <div className={'p-3'}>
                        <ImportCsvFileDropzone
                            onParsed={onFileParsed}
                            requiredFields={requiredFields}
                        />
                    </div>
                </DialogContent>
                <DialogActions className={'p-0'}>
                    <Row className={'w-100 no-gutters'}>
                        <Divider className='divider'/>
                        <Row className='no-gutters justify-content-between align-items-center w-100'>
                            <Button
                                variant={'dialog'}
                                color={'primary'}
                                onClick={close}
                                borderRadius={'0 8px 0 8px'}
                            >
                                Close
                            </Button>
                            <Button
                                variant={'dialog'}
                                color={'primary'}
                                onClick={downloadSampleFile}
                                borderRadius={'8px 0 8px 0'}
                            >
                                Download Sample File
                            </Button>
                        </Row>
                    </Row>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default UploadCsvFileDialog;
